import { useState } from "react";
import { Plus, Trash2, ChevronDown, ChevronUp } from "lucide-react";
import { toast } from "sonner";
import { CATEGORIES, PRODUCTS } from "../../data/store";

export default function Categories() {
  const [cats, setCats] = useState(() => CATEGORIES.map((c) => ({ ...c, subs: [...c.subs] })));
  const [open, setOpen] = useState(null);
  const [newSub, setNewSub] = useState("");

  const addSub = (slug) => {
    if (!newSub.trim()) return;
    setCats((prev) => prev.map((c) => (c.slug === slug ? { ...c, subs: [...c.subs, newSub.trim()] } : c)));
    setNewSub("");
    toast.success("Apakškategorija pievienota (DEMO)");
  };
  const delSub = (slug, s) => {
    setCats((prev) => prev.map((c) => (c.slug === slug ? { ...c, subs: c.subs.filter((x) => x !== s) } : c)));
    toast.success("Apakškategorija dzēsta (DEMO)");
  };

  return (
    <div data-testid="admin-categories">
      <h1 className="text-2xl font-extrabold uppercase tracking-tight mb-5">Kategorijas ({cats.length})</h1>
      <div className="space-y-2">
        {cats.map((c) => {
          const count = PRODUCTS.filter((p) => p.category === c.slug).length;
          const isOpen = open === c.slug;
          return (
            <div key={c.slug} className="bg-white border border-[#E2E2E2]" data-testid={`category-admin-${c.slug}`}>
              <button onClick={() => setOpen(isOpen ? null : c.slug)} className="w-full flex items-center justify-between p-4 text-left hover:bg-[#F5F5F5] transition-colors">
                <div>
                  <span className="font-bold text-sm">{c.name}</span>
                  <span className="text-xs text-[#6B6B6B] ml-3">{c.subs.length} apakškat. · {count} preces</span>
                </div>
                {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </button>
              {isOpen && (
                <div className="border-t border-[#E2E2E2] p-4">
                  <div className="flex flex-wrap gap-2 mb-4">
                    {c.subs.map((s) => (
                      <span key={s} className="flex items-center gap-1.5 text-xs font-semibold bg-[#F5F5F5] px-3 py-1.5">
                        {s}
                        <button onClick={() => delSub(c.slug, s)} className="text-[#D0121A]" aria-label={`Dzēst ${s}`}><Trash2 size={11} /></button>
                      </span>
                    ))}
                  </div>
                  <div className="flex gap-2 max-w-md">
                    <input value={newSub} onChange={(e) => setNewSub(e.target.value)} placeholder="Jauna apakškategorija…" data-testid={`subcat-input-${c.slug}`}
                      className="flex-1 h-9 px-3 border border-[#E2E2E2] text-sm focus:outline-none focus:ring-2 focus:ring-[#111111]" />
                    <button onClick={() => addSub(c.slug)} data-testid={`subcat-add-${c.slug}`} className="bg-[#111111] hover:bg-[#3A3A3A] text-white text-sm font-bold px-3 flex items-center gap-1 transition-colors"><Plus size={14} /> Pievienot</button>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
